import { Component, Input } from '@angular/core';
import { CategoryModel } from '../../providers/categories/categories';

/**
 * Generated class for the MysportSportartListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mysport-sportart-list-item',
  templateUrl: 'mysport-sportart-list-item.html'
})
export class MysportSportartListItemComponent {
  @Input('category')
  category: CategoryModel;
  @Input('selected')
  selected: boolean;
  constructor() {}
}



// WEBPACK FOOTER //
// /src/components/mysport-sportart-list-item/mysport-sportart-list-item.ts